export default "__VITE_ASSET__BI9k5FFB__"